import { useTranslation } from 'react-i18next';
import { useGetModuleSpecsQuery } from '../../../api/queries/getModuleSpecs';
import VehicleAssignmentsSection from '../../shared/VehicleAssignmentsSection';

type VehicleModuleManagementProps = {
    featureModuleId: string;
    index: number;
    disabled?: boolean;
};

const getLocalVehicleModuleId = (id: string) => {
    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            moduleId: id,
        },
    });
    if (!loading) {
        switch (data?.module?.__typename) {
            case 'ConfiguratorModule':
                return { vehicleModuleId: data?.module.vehicleModuleId, displayName: data?.module.displayName };

            default:
                return null;
        }
    }

    return null;
};

const VehicleModuleManagement = ({ featureModuleId, index, disabled = false }: VehicleModuleManagementProps) => {
    const { t } = useTranslation(['labelDetails']);

    const vehicleModule = getLocalVehicleModuleId(featureModuleId);

    return vehicleModule?.vehicleModuleId ? (
        <VehicleAssignmentsSection
            disabled={disabled}
            filter={{ moduleId: vehicleModule?.vehicleModuleId }}
            header={t('labelDetails:tabs.panel.vehicleAssignment', { moduleName: vehicleModule?.displayName })}
            name={`moduleVariants.[${index}].addedVariantSuiteIds`}
        />
    ) : null;
};

export default VehicleModuleManagement;
